import { Box, Tooltip } from "@mui/material";
import { cloneElement } from "react";
import { getTimeOffConfig, TimeOffType } from "../../../utils/timeOffUtils";
import { isLightColor } from "../../../utils/isLightColor";
import { TimeOffItem } from "./useTherapistTimeOff";

type TimeOffIconProps = {
    timeOffs: Array<TimeOffItem>;
    backgroundColor: string;
};

export const TimeOffIcon = ({ timeOffs, backgroundColor }: TimeOffIconProps) => {
    if (timeOffs.length === 0) {
        return null;
    }

    const uniqueTypes = [...new Set(timeOffs.map((t) => t.type))];
    const firstType = uniqueTypes[0] as TimeOffType;
    const config = getTimeOffConfig(firstType);

    if (!config) {
        return null;
    }

    const tooltipLabel = uniqueTypes.map((type) => getTimeOffConfig(type as TimeOffType)?.label).join(", ");
    const isLight = isLightColor(backgroundColor);
    const iconWithStyle = cloneElement(config.icon as React.ReactElement, {
        color: isLight ? "error" : "inherit",
        sx: { fontSize: "0.9rem" },
    });

    return (
        <Tooltip title={tooltipLabel} arrow>
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 4,
                    color: isLight ? "error.main" : "white",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {iconWithStyle}
            </Box>
        </Tooltip>
    );
};

